// What is wrong with the GA choice in step 4, if anything.
//
// Two callers need the same answer: canProceed(), which disables Next, and the
// footer, which has to say why. If they ever drift the broker gets a dead button
// and no explanation.
//
// Since carriers are now picked INSIDE each GA's roster, "a carrier nobody can
// quote" can no longer be built here and is not one of these problems. The
// server still checks for it, because a draft resumed after somebody edited a
// GA's carrier list can arrive holding asks that no longer hold.

import { asksForGeneralAgency } from "@shared/utils/rfpGaCarriers";

export type GaSelectionProblem =
  | { kind: "no-ga-picked" }
  /** Ticked firms whose email would ask for nothing. */
  | { kind: "ga-asked-nothing"; generalAgencyIds: number[] };

export type GaSelectionInput = {
  sendVia: "carriers" | "ga" | undefined;
  selectedGeneralAgencyIds: number[];
  /** "generalAgencyId:carrierId" pairs. */
  asks: string[];
};

export function findGaSelectionProblems(input: GaSelectionInput): GaSelectionProblem[] {
  if (input.sendVia !== "ga") return [];

  if (!input.selectedGeneralAgencyIds.length) return [{ kind: "no-ga-picked" }];

  const askedNothing = input.selectedGeneralAgencyIds.filter(
    (generalAgencyId) => asksForGeneralAgency(input.asks, generalAgencyId).length === 0,
  );
  return askedNothing.length ? [{ kind: "ga-asked-nothing", generalAgencyIds: askedNothing }] : [];
}
